import React from "react";
import {
  Input as BSInput,
} from "reactstrap";

class Input extends React.Component {
  onChange = e => {
    const { name, onChange, type } = this.props;

    if (type === "checkbox") {
      onChange(name, e.target.checked);
    } else {
      onChange(name, e.target.value);
    }
  };

  render () {
    const {
      value,
      style,
      type,
      checked,
      disabled,
      maxLength,
    } = this.props;
    return (
      <BSInput
        value={type === "checkbox" ? undefined : value}
        checked={type === "checkbox" ? checked : undefined}
        onChange={this.onChange}
        style={style}
        type={type}
        disabled={disabled}
        maxLength={maxLength}
      />
    );
  }
}

export default Input;
